import { render, staticRenderFns } from "./SearchMatter.vue?vue&type=template&id=2f0af085"
import script from "./SearchMatter.vue?vue&type=script&lang=js"
export * from "./SearchMatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports